<div #mainApp class="h-full w-full bg-cover bg-center main-app">
  <router-outlet></router-outlet>
  <div [ngClass]="{ visible: overlayVisible }" class="overlay-container">
    <div class="overlay-content-container">
      <router-outlet name="overlay"></router-outlet>
    </div>
  </div>
  <div *ngIf="!isCorrectBrowser && !!isPreview" class="disruptor-overlay incorrect-browser">
    {{incorrectBrowserMessage}}
  </div>
  <div (click)="startPreviewInterval()" *ngIf="showPreviewMsg" class="disruptor-overlay preview">
    {{previewMsg}}
  </div>
</div>
<div class="rotate-screen h-full w-full">
  Bitte Anzeige drehen. Diese Anwendung unterstützt keine Ausrichtung im Hochformat.
</div>
<iframe id="connectorIframe" allow="microphone; camera"></iframe>
<magnifying-glass></magnifying-glass>
<ghosthand></ghosthand>
<div class="no-network" *ngIf="noNetwork">
  <ibex-icon name="globe-warning" variant="blank"></ibex-icon>
  <div class="title">Oops!</div>
  <div class="text">
    <h3>Langsame oder keine Internetverbindung.</h3>
    Bitte überprüfen Sie Ihre Interneteinstellungen und versuchen Sie es erneut.
  </div>
</div>
